import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { IndicatorName } from '@/api/rest/resources/types/fact';
import { ChartHeading } from '@/components/Charts/components/ChartHeading';
import { HabitatIntactnessThreatsBreakdownHistorical } from '@/components/Charts/HabitatIntactnessThreatsBreakdownHistorical';
import { GraphFact } from '@/components/Charts/types';
import { useTrendLabelFromPlotFact } from '@/hooks/useTrendLabelFromFact';
import { NoPlotData } from '@/pages/shared/projects/pages/project/pages/sustainableProduction/pages/plot/components/NoPlotData';

export const HabitatIntactnessThreatsBreakdownGraphTile = ({ data }: { data: GraphFact[] | null | undefined }) => {
  const { t } = useTranslation();

  const trendLabel = useTrendLabelFromPlotFact({
    fact: IndicatorName.threat_breakdown_total_previous_5y_change,
  });

  const noChartData = !data || data.length === 0;

  if (noChartData) {
    return <NoPlotData />;
  }

  return (
    <Stack center data-testid='habitat-intactness-threats-breakdown-graph-tile'>
      <Stack spacing={2.5} className='w-full items-center justify-center px-1 py-6 lg:items-start lg:p-8 lg:pl-1'>
        <ChartHeading
          heading={t('shared.ncaDetail.details.habitatIntactness.threatsBreakdown.labels.graphHeadline')}
          className='w-full px-6 sm:px-0'
          popover={{
            title: t('shared.ncaDetail.details.habitatIntactness.threatsBreakdown.labels.graphHeadline'),
            body: t('shared.ncaDetail.details.habitatIntactness.threatsBreakdown.labels.graphHeadlineTooltip'),
          }}
        />
        <HabitatIntactnessThreatsBreakdownHistorical data={data} trendLabel={trendLabel} />
      </Stack>
    </Stack>
  );
};
